import axiosInstance from './axiosConfig';


// ads_analyses record getting here
export const actionableConditions = async ({ formattedEnd , formattedStart , selectedIds , selectedTab }) => {
  const { productId = [], categoryId = [] , parentProductId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  const parentProductIdStr = parentProductId.join(',');
  const viewType = localStorage.getItem("viewType");

   // ✅ Build query params dynamically
  let url = `/actionable_conditions?start_date=${formattedStart}&end_date=${formattedEnd}&category_ids=${categoryIdsStr}&tab=${selectedTab}&parent_product_id=${parentProductIdStr}`;

  if (viewType === "variation" || viewType === "product") {
    url += `&product_wise=${viewType}`;
  }
  

  const response = await axiosInstance.get(url);
  return response.data;
};